export default {
  brandColor1: '#e35a50',
  complimentaryColor1: '#f0ede5',
  brandColor2: '#e35a50',
  complimentaryColor2: '#f0ede5',
};
